import {
  Divider,
  Form,
  message,
  Modal,
  Input,
  Select,
  Row,
  Col,
  Checkbox,
  TimePicker,
  Button,
  Tooltip,
  Radio,
  DatePicker
} from "antd";
import React, { useState } from "react";
import UIFetchService from "../Service/UIFetchService";
import { isEmpty } from "../Service/Utils";
import {
  PlusOutlined,
  DeleteOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
} from "@ant-design/icons";
import moment from "moment";

import "./customize.scss";
import { useEffect } from "react";
import { RadioChangeEvent } from "antd/lib/radio";
import { Base64 } from 'js-base64';

const NOTICE_KEY = "EDIT_TASK_NOTICE";
const { RangePicker } = DatePicker;

type Props = {
  visible: boolean;
  addOrUpdate: boolean;
  data: any;
  onOk: (params: any, addOrUpdate: boolean) => void;
  onCancel: () => void;
};

export default function EditTaskModal(props: Props) {
  const [form] = Form.useForm();
  const [hint, setHint] = useState(false);
  const [timeVisible, setTimeVisible] = useState(true);

  const [mkTbl, setMkTbl] = useState(1);
  const [effectType, setEffectType] = useState(1);
  const onChangeMkTbl = (e: RadioChangeEvent) => {
    setMkTbl(e.target.value);
  };

  useEffect(() => {
    form.resetFields();
    if (!props.addOrUpdate) {
      const showTime =
        props.data.scheduledAt && props.data.scheduledAt.length > 0
          ? true
          : false;
      form.setFieldsValue({
        ...props.data,
        sql: Base64.decode(props.data.sql),
        scheduledAt: props.data.scheduledAt
          ? moment(props.data.scheduledAt, "HH:mm:ss")
          : null,
        effectDate: props.data.effectDate[0] === ""
        ? [moment(),moment()]
        : [moment(props.data.effectDate[0], "yyyy-MM-DD"),moment(props.data.effectDate[1], "yyyy-MM-DD")],
        effectType: props.data.effectType === 0 ? 1:props.data.effectType
      });
      setMkTbl(props.data.createType)
      setTimeVisible(showTime);
      setEffectType(props.data.effectType)
    } else {
      setTimeVisible(false);
    }
  }, []);

  useEffect(() => {
    if (timeVisible) {
      !form.getFieldValue("scheduledAt") &&
        form.setFieldsValue({ scheduledAt: moment("09:00:00", "HH:mm:ss") });
    }
  }, [timeVisible]);

  useEffect(() => {
    const res = localStorage.getItem(NOTICE_KEY);
    if (res) return;
    setHint(true);
    localStorage.setItem(NOTICE_KEY, "1");
    setTimeout(() => {
      setHint(false);
    }, 5000);
  }, []);

  const onOk = async () => {
    try {
      const values = await form.validateFields();
      console.log(values, props.addOrUpdate);
      // return
      if (props.addOrUpdate) {
        const param: any = {
          tableName: values.tableName,
          createType: values.createType,
          partitionKey: values.partitionKey,
          effectType: values.effectType
        }
        // 建表方式：1. 根据描述建表 2. 建表语句建表
        if (values.createType === 1) {
          param.tableDesc = values.tableDesc
        } else if (values.createType === 2) {
          param.sql = Base64.encode(values.sql)
        }
        const res = await UIFetchService.post(
          `/api/v1/querying_works/dev/pre_create_table`,
          param
        );
        // res 会包含所有的值
        console.log(res)
        if (isEmpty(res?.sql)) {
          message.error(`无法创建表：${values.tableName}`);
          return;
        }
        props.onOk(
          {
            ...values,
            sql: res.sql,
            tableDesc: res.tableDesc,
            scheduledAt: values.scheduledAt
              ? values.scheduledAt.format("HH:mm:ss")
              : null,
            effectDate: values.effectDate
              ? [values.effectDate[0].format("yyyy-MM-DD"),values.effectDate[1].format("yyyy-MM-DD")]
              : null,
          },
          props.addOrUpdate
        );
      } else {
        const param = {
          ...values,
          scheduledAt: values.scheduledAt
            ? values.scheduledAt.format("HH:mm:ss")
            : null,
          effectDate: values.effectDate
            ? [values.effectDate[0].format("yyyy-MM-DD"),values.effectDate[1].format("yyyy-MM-DD")]
            : null,
        }
        if (values.createType === 1) {
          param.sql = props.data.sql
        } else if (values.createType === 2) {
          param.tableDesc = props.data.tableDesc
          param.sql = Base64.encode(values.sql)
        }
        props.onOk(
          param,
          props.addOrUpdate
        );
      }
      
    } catch (error) {
      message.error("配置错误，无法提交");
    }
  };

  const switchIndex = (key: number, dir: "up" | "down") => {
    try {
      if (key === 0 && dir === "up") return;
      const values = form.getFieldsValue();
      if (key === values.tableDesc.columns.length - 1 && dir === "down") {
        return;
      }
      const plus = dir === "up" ? -1 : 1;
      const columns = values.tableDesc.columns.slice();
      const temp = columns[key];
      columns[key] = columns[key + plus];
      columns[key + plus] = temp;

      form.setFieldsValue({
        tableDesc: {
          ...values.tableDesc,
          columns,
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const onValuesChange = (c, all) => {
    if (all.createType) {
      setMkTbl(all.createType)
    }
    
    if (all.effectType) {
      setEffectType(all.effectType)
    }
  }

  return (
    <Modal
      visible={props.visible}
      onCancel={props.onCancel}
      maskClosable={false}
      closable={false}
      onOk={onOk}
      width={800}
      bodyStyle={{ maxHeight: "60vh", overflow: "auto" }}
    >
      <Form
        form={form}
        labelAlign="right"
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 17 }}
        className="customize"
        onValuesChange={onValuesChange}
      >
        <Form.Item
          name="name"
          label="任务名"
          rules={[{ required: true, message: "任务名不能为空" }]}
          wrapperCol={{ span: 10 }}
        >
          <Input disabled={!props.addOrUpdate} />
        </Form.Item>
        <Form.Item
          label="调度"
          style={{ marginBottom: "-5px", marginTop: "-5px" }}
        >
          <Row align="top">
            <Col>
              <Tooltip
                color="#f50"
                placement="top"
                trigger={["hover"]}
                title="每日定时运行任务，时间可自定义"
                visible={hint}
              >
                <Form.Item>
                  <Checkbox
                    checked={timeVisible}
                    onChange={() => setTimeVisible(!timeVisible)}
                  >
                    每日调度
                  </Checkbox>
                </Form.Item>
              </Tooltip>
            </Col>
            {timeVisible && (
              <Col>
                <Form.Item
                  name="scheduledAt"
                  initialValue={moment("09:00:00", "HH:mm:ss")}
                  rules={[{ required: true, message: "请选择每日调度时间" }]}
                >
                  <TimePicker size="small" format="HH:mm:ss" />
                </Form.Item>
              </Col>
            )}
          </Row>
        </Form.Item>
        {timeVisible && <Form.Item
          label="生效日期"
          style={{ marginBottom: "-5px", marginTop: "-5px" }}
        >
          <Row align="top">
            <Col>
            <Form.Item name="effectType" initialValue={1}>
              <Radio.Group>
                <Radio value={1}>永久生效</Radio>
                <Radio value={2}>指定时间</Radio>
              </Radio.Group>
            </Form.Item>
            </Col>
            {effectType === 2 && (
              <Col>
                <Form.Item
                  name="effectDate"
                  initialValue={[moment(), moment()]}
                  rules={[{ required: true, message: "请选择生效日期" }]}
                >
                  <RangePicker
                    defaultValue={[moment(), moment()]}
                  />
                </Form.Item>
                
              </Col>
            )}
          </Row>
        </Form.Item>}
        <Form.Item
          name="tableName"
          label="表名"
          rules={[
            { required: true, message: "表名不能为空" },
            { pattern: /^[\w]+$/, message: "表名不正确" },
          ]}
          wrapperCol={{ span: 10 }}
        >
          <Input addonBefore="tmp_" />
        </Form.Item>
        <Tooltip
          color="#f50"
          placement="top"
          trigger={["hover"]}
          title="可以选择以外部表的形式导入Hologres"
          visible={hint}
        >
          <Form.Item label="关联HOLO库" name="associatedHoloDb" initialValue="">
            <Select>
              <Select.Option value="">不关联</Select.Option>
              <Select.Option value="bcz_datap_strategy">
                bcz_datap_strategy
              </Select.Option>
              <Select.Option value="datap_finance">datap_finance</Select.Option>
              <Select.Option value="datap_nocturne">
                datap_nocturne
              </Select.Option>
              <Select.Option value="datap_bcz">datap_bcz</Select.Option>
              <Select.Option value="datap_mintpie">datap_mintpie</Select.Option>
            </Select>
          </Form.Item>
        </Tooltip>

        <Form.Item label="说明" name={["tableDesc", "comment"]} initialValue="">
          <Input />
        </Form.Item>
        <Form.Item label="建表方式" name="createType" initialValue={1}>
          <Radio.Group>
            <Radio value={1}>手动建表</Radio>
            <Radio value={2}>代码建表</Radio>
          </Radio.Group>
        </Form.Item>

        {mkTbl === 1 && (
          <>
            <Row justify="center">
              <Col>
                <h4>字段列表</h4>
              </Col>
            </Row>
            <Divider style={{ margin: "3px" }} />
            <Row>
              <Col flex="30%" style={{ textAlign: "center" }}>
                <span>字段名</span>
              </Col>
              <Col flex="20%" style={{ textAlign: "center" }}>
                <span>数据类型</span>
              </Col>
              <Col flex="30%" style={{ textAlign: "center" }}>
                <span>描述</span>
              </Col>
            </Row>
            <Form.List name={["tableDesc", "columns"]}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map((field) => (
                    <Row key={field.key}>
                      <Col flex="30%">
                        <Form.Item
                          {...field}
                          name={[field.name, "name"]}
                          wrapperCol={{ span: 22, offset: 1 }}
                          rules={[
                            { required: true, message: "列名不能为空" },
                            {
                              pattern: /^[_a-zA-Z]\w*$/,
                              message: "列名不正确",
                            },
                          ]}
                        >
                          <Input
                            size="small"
                            style={{ width: "100%", height: 24 }}
                          />
                        </Form.Item>
                      </Col>
                      <Col flex="20%">
                        <Form.Item
                          {...field}
                          wrapperCol={{ span: 22, offset: 1 }}
                          name={[field.name, "type"]}
                          rules={[
                            { required: true, message: "没有选择列类型" },
                          ]}
                        >
                          <Select size="small" style={{ width: "100%" }}>
                            <Select.Option value="BIGINT">
                              <code style={{ fontSize: 12 }}>BIGINT</code>
                            </Select.Option>
                            <Select.Option value="DECIMAL">
                              <code style={{ fontSize: 12 }}>DECIMAL</code>
                            </Select.Option>
                            <Select.Option value="STRING">
                              <code style={{ fontSize: 12 }}>STRING</code>
                            </Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col flex="30%">
                        <Form.Item
                          {...field}
                          name={[field.name, "comment"]}
                          wrapperCol={{ span: 22, offset: 1 }}
                        >
                          <Input size="small" />
                        </Form.Item>
                      </Col>
                      <Col flex="20%">
                        <Button
                          size="small"
                          type="link"
                          icon={<DeleteOutlined />}
                          danger
                          onClick={() => remove(field.name)}
                        />
                        <Button
                          size="small"
                          type="link"
                          icon={<ArrowUpOutlined />}
                          onClick={() => {
                            switchIndex(field.key, "up");
                          }}
                        ></Button>
                        <Button
                          size="small"
                          type="link"
                          icon={<ArrowDownOutlined />}
                          onClick={() => {
                            switchIndex(field.key, "down");
                          }}
                        ></Button>
                      </Col>
                    </Row>
                  ))}
                  <Row>
                    <Col flex="100%">
                      <Tooltip
                        color="#f50"
                        placement="top"
                        trigger="hover"
                        title="点此新建一列"
                        visible={hint}
                      >
                        <Button
                          style={{ width: "100%" }}
                          icon={<PlusOutlined />}
                          size="small"
                          type="link"
                          onClick={() => add()}
                        >
                          增加一列
                        </Button>
                      </Tooltip>
                    </Col>
                  </Row>
                </>
              )}
            </Form.List>
          </>
        )}
        {mkTbl === 2 && (
          <Form.Item
            name="sql"
            rules={[{ required: true, message: "请输入建表语句" }]}
            wrapperCol={{ offset: 1 }}
          >
            <Input.TextArea
              style={{ resize: "none" }}
              rows={7}
              placeholder="请输入建表语句"
            />
          </Form.Item>
        )}
        {!props.addOrUpdate && (
          <Row style={{ margin: "0 0 10px 0" }}>
            <Col>
              <span style={{ color: "red" }}>
                注意：修改表结构将会导致临时表已有的数据丢失。
              </span>
            </Col>
          </Row>
        )}
        <Row>
          <Col span={8}>
            <Form.Item
              name="partitionKey"
              label="分区键"
              labelCol={{ span: 12 }}
              wrapperCol={{ span: 12 }}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="partitionFormat"
              label="分区格式"
              labelCol={{ span: 12 }}
              wrapperCol={{ span: 12 }}
            >
              <Select allowClear={true}>
                <Select.Option value={"yyyymmdd"}>yyyymmdd</Select.Option>
                <Select.Option value={"yyyymm"}>yyyymm</Select.Option>
                <Select.Option value={"yyyy"}>yyyy</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="partitionGranularity"
              label="分区粒度"
              labelCol={{ span: 12 }}
              wrapperCol={{ span: 12 }}
            >
              <Select allowClear={true}>
                <Select.Option value={"日"}>日</Select.Option>
                <Select.Option value={"周"}>周</Select.Option>
                <Select.Option value={"月"}>月</Select.Option>
                <Select.Option value={"年"}>年</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
